// Libs
import { Box, Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { DropzoneProps, DropzoneRef, useDropzone } from 'react-dropzone';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IBaseFile } from '~/utils/interface/common';
import { FILE_UPLOAD_PROP_MIN_FILE, FILE_UPLOAD_PROP_MAX_FILE } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseUploadFile.module.scss';
import { icons } from '~/assets';

export type BaseUploadFileProps = DropzoneProps &
  React.RefAttributes<DropzoneRef> & {
    onChange?: (files: IBaseFile[]) => void;
    uploadedFiles?: IBaseFile[];
    isMultiple?: boolean;
    errorMessage?: string;
  };

const cx = classNames.bind(styles);

const BaseUploadFile = (props: BaseUploadFileProps) => {
  //#region Destructuring Props
  const {
    isMultiple = true,
    maxFiles = isMultiple ? FILE_UPLOAD_PROP_MAX_FILE : FILE_UPLOAD_PROP_MIN_FILE,
    errorMessage,
    ...restProps
  } = props;
  delete restProps.onChange;
  //#endregion Destructuring Props
  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles,
    multiple: isMultiple,
    ...restProps,
    onDrop: (acceptedFiles: Array<File>) => {
      const updatedFiles = [
        ...uploadFiles,
        ...acceptedFiles.map((item) => ({
          file: item,
          name: item.name,
        })),
      ];
      setUploadFiles(updatedFiles);

      if (props.onChange) {
        props.onChange(updatedFiles);
        setUploadFiles([]);
      }
    },
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [uploadFiles, setUploadFiles] = useState<IBaseFile[]>([]);
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props?.uploadedFiles?.length) {
      setUploadFiles([...props.uploadedFiles.filter((uploadedFile) => !!uploadedFile?.url)]);
    }
  }, [props?.uploadedFiles]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function
  return (
    <Box>
      {uploadFiles.length < maxFiles && (
        <>
          <Box className={cx('container')} {...getRootProps()}>
            <input {...getInputProps()} />

            <img src={icons.commonIconUploadFile} alt={t('common_alt_img')} className={cx('icon')} />

            <Typography className={cx('description')}>{t('common_description_add_file')}</Typography>

            <Typography className={cx('maxFileSize')}>{t('common_description_max_file_size')}</Typography>
          </Box>

          <Typography className={cx('errorMessage')}>{errorMessage}</Typography>
        </>
      )}
    </Box>
  );
};
export default memo(BaseUploadFile);
